import { Pessoa } from "@tivic-team/manager-ts/dist/grl";
import { Agente } from "@tivic-team/manager-ts/dist/mob/entities/agente.entity";
import { AfericaoCatraca } from "@tivic-team/manager-ts/dist/mob/entities/concessao/afericao-catraca.entity";
import { ConcessaoVeiculo } from "@tivic-team/manager-ts/dist/mob/entities/concessao/concessao-veiculo.entity";
import { ImpedimentoAfericao } from "@tivic-team/manager-ts/dist/mob/entities/concessao/impedimento-afericao.entity";
import { Lacre } from "@tivic-team/manager-ts/dist/mob/entities/lacre/Lacre.entity";

export class AfericaoCatracaDTO extends AfericaoCatraca{
    
    lacre: Lacre = void(0);
    agente: Agente = void(0);
    concessaoVeiculo: ConcessaoVeiculo = void(0);
    impedimentosAfericao: Array<ImpedimentoAfericao> = void(0);
    pessoa: Pessoa = void(0);
      
    constructor() {
        super();
    }
   
}

export class AfericaoCatracaListDTO {
    items: Array<AfericaoCatracaDTO>;
    total: number;

    constructor() {}
}